var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-item',_vm._b({attrs:{"label":_vm.matchFieldKeyLabel || _vm.$t('network_waf_statement.label.match_field_key')}},'a-form-item',_vm.formLayout,false),[(_vm.isEdit)?_c('a-input',{attrs:{"value":_vm.value}}):_c('box-show',{attrs:{"value":_vm.value}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }